import { useSelector } from "react-redux";
import { Cart } from "../interfaces/Cart";
import { StoreState } from "../interfaces/storeState";

export const useCartSelections = (): Cart => useSelector(getCartSelections);

const getCartSelections = (state: StoreState): Cart => {
  if (!state.cartSelections) {
    return undefined;
  }

  return state.cartSelections;
};
